import globalStyle from '@/styles/Global.scss';
import style from './Uketori.scss'
import React, {useEffect, useState} from "react";
import Layout from "@/layout/Layout";
import {useHistory, useParams} from "react-router";
import ImageCard from "@/components/ImageCard";
import {getUketoriCard, updateUketoriCard} from "@/api/exchange";
import {CardExchange} from "@/entity/CardExchange";
import MButton from "@/components/atom/MButton";
import {yyyymmdd} from "@/util/date";

const UketoriCardMemo = () => {
  const history = useHistory()
  const {id} = useParams()
  const [cardExchange, setCardExchange] = useState(null)

  useEffect(() => {
    (async () => {
      const cardExchange = await getUketoriCard({id})
      setCardExchange(cardExchange)
    })()
  }, [id])

  const toBack = () => {
    history.push(`/uketori/${id}`)
  }

  const save = async () => {
    await updateUketoriCard({id, cardExchange})
    history.push(`/uketori/${id}`)
  }

  const update = (delta) => {
    setCardExchange(new CardExchange({...cardExchange, ...delta}))
  }

  return (
    <>
      <Layout category={'UK'}>
        {
          cardExchange &&
          <div className={globalStyle.container}>
            <ImageCard id={cardExchange.card.id}></ImageCard>
            <div className={style.attribute}>
              <div className={style.title}>
                受取日
              </div>
              <div className={style.value}>
                {yyyymmdd(cardExchange.receivedAt)}
              </div>
            </div>
            <div className={style.attribute}>
              <div className={style.title}>
                メモ
              </div>
              <div className={style.value}>
                <textarea onChange={(e) => update({memo: e.target.value})} defaultValue={cardExchange.memo}/>
              </div>
            </div>
            <div className={style.attribute}>
              <div className={style.title}>
                評価
              </div>
              <div className={style.value}>
                <select value={cardExchange.score || 0} onChange={(e) => update({score: e.target.value})}>
                  <option value={0}></option>
                  <option value={1}>☆</option>
                  <option value={2}>☆☆</option>
                  <option value={3}>☆☆☆</option>
                </select>
              </div>
            </div>
            <div>
              <div className={globalStyle.footerContainer}>
                <div className={globalStyle.footer}>
                  <div className={globalStyle.centerPanel}>
                    <MButton image={'hozon.png'} value={'保存'} onClick={save}></MButton>
                    <MButton image={'back.png'} value={'戻る'} onClick={toBack}></MButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </Layout>
    </>
  )
}

export default UketoriCardMemo
